import { axios } from 'api'

export type AccountInfo = {
  firstName: string
  lastName: string
  email: string
  companyName: string
  phoneNumber: string
  salesRep: string
  isTermCustomer: boolean
}

export interface UpdateAccountInfoParams {
  firstName?: string
  lastName?: string
  companyName?: string
  phoneNumber?: string
}

export const getAccountInfo = async (): Promise<{
  success: boolean
  data?: AccountInfo
}> => {
  const response = await axios.get('/accounts/me')
  if (response.status === 200) {
    return { success: true, data: response.data }
  } else {
    return { success: false }
  }
}

export const requestPasswordReset = async (email?: string) => {
  const response = await axios.post('/accounts/password-reset/request', {
    email
  })

  if (response.status === 200) {
    return { success: true }
  } else {
    return {
      success: false,
      error: response.data.error || 'Password reset failed. Please try again.'
    }
  }
}

export const confirmPasswordReset = async (
  code: string,
  newPassword: string,
  email?: string
) => {
  const response = await axios.post('/accounts/password-reset/confirm', {
    code,
    newPassword,
    email
  })

  if (response.status === 200) {
    return { success: true }
  } else {
    return {
      success: false,
      error: response.data.error || 'Password reset failed. Please try again.'
    }
  }
}
